import {Field, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {MDBCol, MDBRow} from "mdbreact"
import {useEffect, useState} from "react"
import {
    fetchBookingCountDetail,
    fetchBookingCountVehicleTypeDetail,
    fetchPassRateCountDetail,
    fetchPerformanceCountDetail,
    fetchProfitOrLossMonthlyDetail,
    fetchTestTypeCountDetail,
    setDashboardFiltersAction,
} from "../../containers/Dashboard/dashboardSlice"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import DealerDropdown from "../Shared/dealerDropdown"

const DashboardFilters = () => {
    const dispatch = useAppDispatch()

    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)

    useEffect(() => {
        const dashboardparam = {
            selectedDealer,
        }

        dispatch(setDashboardFiltersAction(dashboardparam))

        if (selectedDealer) {
            dispatch(fetchBookingCountVehicleTypeDetail(dashboardparam))
            dispatch(fetchPassRateCountDetail(dashboardparam))
            dispatch(fetchTestTypeCountDetail(dashboardparam))
            dispatch(fetchPerformanceCountDetail(dashboardparam))
            dispatch(fetchProfitOrLossMonthlyDetail(dashboardparam))
            dispatch(fetchBookingCountDetail(dashboardparam))
        }
    }, [selectedDealer])

    return (
        <Form
            render={(formRenderProps: FormRenderProps) => (
                <MDBRow className="mb-2">
                    <MDBCol md="2" sm="2">
                        <FormElement>
                            <Field name={"plannerDealerID"} component={DealerDropdown} />
                        </FormElement>
                    </MDBCol>
                </MDBRow>
            )}
        />
    )
}

export default DashboardFilters
